<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="16">
        <el-input v-model="publisherName" style="width:200px;" placeholder="出版社名称"></el-input>
        <el-input v-model="publisherOrgin" style="width:200px;" placeholder="所属地区"></el-input>
      </el-col>
      <el-col :span="8">
        <el-button @click="handleQuery">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        :data="gridData"
        border
        highlight-current-row
        @current-change="handleCurrentChange"
        max-height="240"
      >
        <el-table-column property="orgName" label="出版社名称" width="150"></el-table-column>
        <el-table-column property="province" label="所属地区" width="200"></el-table-column>
      </el-table>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取 消</el-button>
      <el-button type="primary" @click="handleOk">确认选择</el-button>
    </span>
  </div>
</template>
<script>
import { queryPublisher } from "@/api/sysinfo";
export default {
  name: "publisherSelect",
  data() {
    return {
      gridData: [],
      currentRow: {},
      publisherName: "",
      publisherOrgin: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleCancle() {
      this.$emit("close");
    },
    handleOk() {
      this.$emit("close", this.currentRow);
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    // 查询
    handleQuery() {
      let params={
        orgType:3,
        province:this.publisherOrgin,
        orgName:this.publisherName
      }
      queryPublisher(params).then(data => {
        this.gridData = data;
      });
    },
    // 重置
    handleReset() {
      this.publisherName = "";
      this.publisherOrgin = "";
    },
    getData() {
      queryPublisher({ orgType: 3 }).then(data => {
        this.gridData = data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/views/SysManager/ClassifyInfo/components/publisherSelect.vue